import { render } from "./PropertyPanel.vue?vue&type=template&id=b804ccfa&scoped=true"
import script from "./PropertyPanel.vue?vue&type=script&lang=js"
export * from "./PropertyPanel.vue?vue&type=script&lang=js"

import "./PropertyPanel.vue?vue&type=style&index=0&id=b804ccfa&lang=css"
import "./PropertyPanel.vue?vue&type=style&index=1&id=b804ccfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b804ccfa"]])

export default __exports__